// src/components/EditorTexto.jsx
//
// Wrapper de react-quill con la barra de herramientas completa que pide
// Calidad para Auditorías: negritas, cursiva, subrayado, viñetas,
// numerado, y alineación (izquierda/centro/derecha/justificado).

import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const MODULOS = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }], // incluye izquierda (default), centro, derecha, justificado
    ['clean'],
  ],
};

export default function EditorTexto({ value, onChange, placeholder }) {
  return (
    <ReactQuill
      theme="snow"
      value={value || ''}
      onChange={onChange}
      modules={MODULOS}
      placeholder={placeholder}
      style={{ background: '#FFFDF7', fontFamily: 'Inter, sans-serif' }}
    />
  );
}